export default "__VITE_ASSET__125f87fd__"